/**
 * Returns an array of unique items from the provided arrays, excluding null and undefined values.
 *
 * @template T - The type of the items in the arrays.
 * @param {...Array<Array<T | null | undefined>>} arrays - One or more arrays to extract unique items from.
 * @returns {T[]} An array of unique items.
 */
export function getUniqueItems<T>(
  ...arrays: Array<Array<T | null | undefined>>
): T[] {
  const combined = arrays.flat()
  const unique = new Set<T>(
    combined.filter((item): item is T => item !== null && item !== undefined)
  )
  return Array.from(unique)
}
